<template>
  <div>
    <el-dialog
      :visible.sync="recordDialogVisible"
      title="型号图片集"
      width="830px"
      @cancel="updateVal"
      @close="updateVal"
    >
      <div class="imgAll">
        <div class="img-box" v-for="(item,index) in dialogData" :key="index">
          <div @click="add(item)">
            <el-image
              :src="item.photoUrl ? item.photoUrl : img_err"
              fit="contain"
              arrow="always"
              :autoplay="false"
              class="pic-item"
            ></el-image>
            <el-card class="text-box">
              <div>{{item.productName}} <span v-show="item.color">颜色：{{item.color}}</span></div>
              <div>日常活动到手价：{{item.price}} <span v-show="item.style">风格：{{item.style}}</span></div>
          </el-card>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { assignValue } from "@/utils";
import img_err from '@/assets/images/img_err.png'
export default {
  model: {
    prop: "visible",
    event: "input",
  },
  props: {
    visible: Boolean,
    dialogData: Array
  },
  computed: {
  },
  data() {
    return {
      recordDialogVisible: false,
      img_err
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.recordDialogVisible = this.visible;
    },
    add(item) {
      this.$emit('bigModelAdd',item)
    },
    updateVal() {
      setTimeout((_) => {
        this.$emit("dialog", false);
      }, 200);
    },
  },
};
</script>

<style lang="stylus" scoped>
.imgAll {
  max-height: 550px;
  display: flex
  flex-wrap: wrap
  overflow-x: auto
  // background: blue;
}

.img-box {
  padding: 0 10px 10px 0;
  width: 250px;
  // background: red;
}

.pic-item
    width 100%
    height 220px

.text-box {
  height: 40px
  line-height: 20px
}

.text-box div {
  text-align: center
  font-size: 12px
}

>>> .el-card__body {
  padding: 0
  background: #F4F4F4;
}
</style>>

